/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import EguMachineRentalInUpdateDialog from "../dialogTypes/EguMachineRentalInUpdateDialog";

function EguMachineRentalInUpdateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, onSuccess, grid, modifyUrlCallback, ...others} = props;
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const onOpen = () => {
        if(grid) {
            setFormData({...(grid.selectedItems[0])});
        }
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"update-button"} onClick={onOpen} {...others} />
            <EguMachineRentalInUpdateDialog
                id={id + "update-dialog"}
                mode="edit"
                title={schema ? t(`dialog.title.${schema.name}.update`) : ""}
                schema={schema}
                initialData={formData}
                open={open}
                grid={grid}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                modifyUrlCallback={modifyUrlCallback}
            />
        </>
    );
}

export default EguMachineRentalInUpdateButton;

